// extracted by mini-css-extract-plugin
module.exports = {"blockWithTwoCard":"styles_blockWithTwoCard__1-SeO","account_number_block":"styles_account_number_block__2hS_u"};